import myAjax from './myAjax.js';

function newlineToBr(text, type) {
  if (type === 'brief_answer' || type === 'answer' || type === 'guide_to_chatfront') {
    var json_string = {text: text, link_str: ''};
    myAjax('/api/qa_data/convert_url/', json_string, 'POST', false).done((data) => {
      if (data) {
        text = data;
      }
    });
  } else {
    text = text.replace(/\n/g, '<br />');
    let exp = new RegExp('((https?|ftp|file)://[-A-Z0-9+&@#/%?=~_|!:,.;{}]*[-A-Z0-9+&@#/%=~_|])', 'gi');
    text = text.replace(exp, "<a href='$1' target='_blank'>$1</a>");
  }

  return {__html: text};
}

export default newlineToBr;
